const chains = {
  arbitrum: 42161,
  arbitrumGoerli: 421613,
  arbitrumSepolia: 421614,
};

const activeChain = chains.arbitrumSepolia;

module.exports = { activeChain };
